import React, { useState, useEffect } from "react";
import {
  TableContainer,
  Paper,
  Typography,
  Box,
  PaginationItem,
} from "@mui/material";
import { api, get, post, put } from "../../../../utils/api";
import { styled } from "@mui/material/styles";
import PaginationBox from "../../../../Components/Masters/Pagination";
import DeleteDialog from "../../../../Components/Masters/DeleteDialog";
import ColumnHeadings from "../../../../Components/Masters/ColumnHeadings";
import MenuActions from "../../../../Components/Masters/MenuActions";
import TableContent from "../../../../Components/Masters/TableContent";
import FilterDrawer from "../../../../Components/Masters/FilterDrawer";
import TopMenu from "../../../../Components/Masters/TopMenu";
import MessagePopup from "../../../../Components/Masters/MessagePopup";
import TableHeading from "../../../../Components/Masters/TableHeading";
import MenuIcon from "../../../../Components/Masters/MenuIcon";
import AddOnRoadVahicle from "./AddVehicle";
import ViewOnRoadVahicle from "./View";
import DateRangePickerComponent from "../../../Masters/Roles and Permissions/Filters/Date";
import MultiSelect from "../../../Masters/Roles and Permissions/Filters/MultiSelect";
import Range from "../../../Masters/Roles and Permissions/Filters/Range";
import NoDataFound from "../../../../Components/Masters/NoDataFound";
import { getMonthName } from "../../../../utils/getMonthName";
import Scope1Layout from "../../../../Layout/Scope1Layout";
import MainDashboardLayout from "../../../../Layout/MainDashboardLayout";
import Cards from "../../../../Components/Common/Cards";
import MonthYearFilter from "../../../Masters/Roles and Permissions/Filters/MonthYearFilter";
import Unauthorized from "../../../../Components/Unauthorized/Unauthorized";
import BulkUploadModal from "../../../../Components/Common/BulkUploadModal";
import TopMenuUpload from "../../../../Components/Masters/TopMenuUpload";
import {
  formatNumberCommaSeparated,
  truncateNumber,
} from "../../../../utils/common";
import BulkUpload from "./BulkUpload";
import DeleteAlertDialog from "../../../../Components/Masters/DeleteAlertDialog";

const OnRoadVahicle = () => {
  const [data, setData] = useState([]);
  const [sortConfig, setSortConfig] = useState({
    key: "createdAt",
    direction: "desc",
  });

  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedData, setSelectedData] = useState(null);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [addData, setAddData] = useState(false);
  const [appliedFilters, setAppliedFilters] = useState({
    Date: false,
    "Consumption Month": false,
    Ownership: false,
    "Vehicle Type": false,
    "Fuel Type": false,
    "Fuel Consumed": false,
    "Distance Covered": false,
  });
  const [viewData, setViewData] = useState(false);
  const [element, setElement] = useState(null);
  const [deleteDialog, setDeleteDialog] = useState(false);
  const [limit] = useState(10); // Number of items per page
  const [selectedFilter, setSelectedFilter] = useState("Date");
  const [drawerFilterOpen, setDrawerFilterOpen] = useState(false);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [snackOpen, setsnackOpen] = useState({
    open: false,
    message: "",
    severity: "",
  });
  const [uniqueValues, setUniqueValues] = useState({});
  const [errors, setErrors] = useState({
    Date: false,
    "Consumption Month": false,
    Ownership: false,
    "Vehicle Type": false,
    "Fuel Type": false,
    "Fuel Consumed": false,
    "Distance Covered": false,
  });
  const [isFiltersApplied, setIsFiltersApplied] = useState(false);
  const [selectedFields, setSelectedFields] = useState({
    ownershipType: [],
    vehicleType: [],
    fuelType: [],
  });
  const [quantityRange, setQuantityRange] = useState({ min: "", max: "" });
  const [distanceRange, setDistanceRange] = useState({ min: "", max: "" });
  const [apiData, setApiData] = useState({ total: [] });
  const [selectedFuelType, setSelectedFuelType] = useState(""); // For 1st card dropdown
  const [selectedMonth, setSelectedMonth] = useState(new Date().getMonth() + 1); // Current month
  const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());
  const [startMonth, setStartMonth] = useState(null);
  const [endMonth, setEndMonth] = useState(null);
  const [formDataBulkUpload, setFormDataBulkUpload] = useState({});
  const [bulkUploadModal, setBulkUploadModal] = useState(false);
  const [excelData, setExcelData] = useState(null);
  const [jsonBulkUpload, setJsonBulkUpload] = useState([]);

  const [tempFilter, setTempFilter] = useState({
    startDate: null,
    endDate: null,
    ownershipType: [],
    vehicleType: [],
    fuelType: [],
    quantityRange: { min: "", max: "" },
    distanceRange: { min: "", max: "" },
    startMonth: null,
    endMonth: null,
  });

  const [matchData, setMatchData] = useState([]);
  const [bulkUploadTable, setBulkUploadTable] = useState(true);
  const bulkuploadInputData = [
    {
      fieldName: "transportType",
      title: "Transport Type",
      options: ["Passenger", "Freight"],
      placeholder: "Tap to select",
      type: "select",
    },
    {
      fieldName: "ownership",
      title: "Ownership",
      options: ["Company Owned", "Leased"],
      placeholder: "Tap to select",
      type: "select",
    },
    {
      fieldName: "logisticsVendor",
      title: "Logistics Vendor",
      type: "select",
      field: "logisticVendorLegalName",
      url: `${api}/master/scope1/logistic/vendorMaster`,
    },
    {
      fieldName: "vehicleNumber",
      title: "Vehicle Number",
      type: "text",
      placeholder: "Type here",
    },
    {
      fieldName: "vehicleCategory",
      title: "Vehicle Category",
      options: [
        "Heavy Commercial Vehicles (HCV)",
        "Medium Commerical Vehicles (MCV)",
        "Light Commerical Vehicles (LCV)",
      ],
      type: "select",
    },
    {
      fieldName: "vehicleType",
      title: "Vehicle Type",
      type: "select",
    },
    {
      fieldName: "brand",
      title: "Brand",
      type: "text",
      placeholder: "Type here",
      // url: `${api}/master/getAllBrand`,
    },
    {
      fieldName: "model",
      title: "Model",
      type: "text",
      placeholder: "Type here",
      // url: `${api}/master/getAllModel`,
    },
    {
      fieldName: "purchaseDate",
      title: "Purchase Date",
      type: "date",
      placeholder: "dd/mm/yyyy",
    },
    {
      fieldName: "lastServiceDate",
      title: "Last Service Date",
      type: "date",
      placeholder: "dd/mm/yyyy",
    },
    {
      fieldName: "fuelType",
      title: "Fuel Type",
      options: [
        "Diesel (average biofuel blend)",
        "Diesel (100% mineral diesel)",
        "Petrol (average biofuel blend)",
        "Petrol (100% mineral petrol)",
        "CNG",
        "Electricity",
      ],
      type: "select",
    },
    {
      fieldName: "bharatStageEmissionType",
      title: "Bharat Stage Emission Type",
      options: [
        "India 2000 (Euro 1)",
        "BS II (Euro 2)",
        "BS III (Euro 3)",
        "BS IV (Euro 4)",
        "BS V (Euro 5)",
        "BS VI (Euro 6)",
      ],
      type: "select",
    },
    {
      fieldName: "declaredEfficiency",
      title: "Declared Efficiency",
      placeholder: "Enter Number",
    },
    {
      fieldName: "loadCapacity",
      title: "Load Capacity (tonnes)",
      placeholder: "Enter Number",
      type: "number",
    },
    {
      fieldName: "passengerCapacity",
      title: "Passenger Capacity (persons)",
      placeholder: "Enter Number",
      type: "number",
    },
  ];

  const uploadErrorClose = () => {
    setBulkUploadTable(true);
  };

  const fetchExcelData = async () => {
    await get("/scope1/mobileCombustion/onroad/equipment")
      .then((res) => {
        let data = res.data.data;
        let arr = data.map((el, idx) => {
          return {
            "Month (in 01/25 or Jan-25)": "",
            "Vehicle Number": el?.vehicleNumber,
            "Fuel Consumed": "",
            "Distance Covered (Km)": "",
            "Remark (optional)": "",
          };
        });
        setExcelData(arr);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    fetchExcelData();
  }, []);

  const handleCloseBulkUpload = () => {
    setBulkUploadModal(false);
    fetchData();
  };

  const selectedFuelData = apiData.fuel?.find(
    (item) => item.fuelType === selectedFuelType
  );

  const breakdownMap = {
    "Company Owned": 0,
    Leased: 0,
  };

  selectedFuelData?.ownershipTypeBreakdown?.forEach((entry) => {
    breakdownMap[entry.ownershipType] = entry.totalFuelConsumed;
  });

  const bannerData = [
    {
      title: "Total Fuel Consumed",
      description: apiData.total
        .filter((item) => item.fuelType === selectedFuelType)
        .map((item) =>
          formatNumberCommaSeparated(
            truncateNumber(item.totalQuantityConsumed ?? 0)
          )
        ),
      unit: apiData.total
        .filter((item) => item.fuelType === selectedFuelType)
        .map((item) => item.unit),
      filter: "option",
      filterValues: uniqueValues.fuelType || [],
      defaultValue: selectedFuelType,
      key: "fuelType",
    },
    {
      title: "Ownership Fuel Consumption",
      description: null,
      chartData: [breakdownMap["Company Owned"], breakdownMap["Leased"]],
      labels: ["Company Owned", "Leased"],
      backgroundColors: ["#FF6384", "#36A2EB"],
      key: "ownership",
    },
    {
      title: "Consumption Month",
      description:
        apiData.monthly
          ?.map(
            (item) =>
              `${formatNumberCommaSeparated(
                truncateNumber(item.totalQuantityConsumed)
              )} ${item.unit}`
          )
          ?.join(", ") || "N/A",
      filter: "date",
      defaultValue: { month: selectedMonth, year: selectedYear },
      key: "monthly",
    },
  ];

  const filters = [
    "Date",
    "Consumption Month",
    "Ownership",
    "Fuel Consumed",
    "Fuel Type",
    "Distance Covered",
  ];

  const inputData = [
    {
      fieldName: "consumptionPeriod",
      title: "Consumption Month",
      required: true,
      type: "date",
    },
    {
      fieldName: "transportType",
      title: "Transport Type",
      options: ["Passenger", "Freight"],
      placeholder: "Tap to select",
      type: "select",
      required: true,
    },
    {
      fieldName: "ownershipType",
      title: "Ownership",
      placeholder: "Select Ownership Type",
      type: "select",
      options: ["Company Owned", "Leased"],
      required: false,
    },
    {
      fieldName: "logisticsVendor",
      title: "Logistic Vendor",
      placeholder: "Select Logistic Vendor",
      type: "select",
      url: `/master/scope1/logistic/vendorMaster`,
      field: "logisticVendorLegalName",
      required: false,
    },
    {
      fieldName: "vehicleNumber",
      title: "Vehicle Number",
      placeholder: "Type here",
      type: "String",
      required: true,
      disabled: true,
    },

    {
      fieldName: "fuelType",
      title: "Fuel Type",
      placeholder: "Type here",
      type: "String",
      // required: true,
    },
    {
      fieldName: "fuelConsumed",
      title: "Fuel Consumed",
      placeholder: "Enter Fuel Consumed ",
      type: "number",
      condition: true,
      adornmentText: "",
    },
    {
      fieldName: "distanceCovered",
      title: "Distance Covered",
      placeholder: "Km",
      type: "number",
      required: true,
    },
    {
      fieldName: "remarks",
      title: "Remark (optional)",
      placeholder: "Additional remarks",
      type: "text",
    },
    {
      fieldName: "editRemarkReason",
      title: "Edit Remark Reason",
      placeholder: "Additional edit remarks",
      type: "text",
      condition: true,
    },
    {
      fieldName: "documents",
      title: "Upload Documents (optional)",
      type: "file",
    },
  ];

  const fetchUniqueValues = async () => {
    try {
      const response = await get(
        `/scope1/mobileCombustion/getAllOnRoadVehicles`
      );
      const data = response.data.data;

      const uniqueOwnershipType = [
        ...new Set(data.map((el) => el.ownershipType).filter(Boolean)),
      ];

      const uniqueVehicleType = [
        ...new Set(data.map((el) => el.vehicleType).filter(Boolean)),
      ];
      const uniqueFuelType = [
        ...new Set(data.map((el) => el.fuelType).filter(Boolean)),
      ];

      setSelectedFuelType(uniqueFuelType?.[0]);

      return {
        ownershipType: uniqueOwnershipType,
        vehicleType: uniqueVehicleType,
        fuelType: uniqueFuelType,
      };
    } catch (error) {
      console.error("Error fetching unique values:", error);
      return {};
    }
  };

  // fetching Vehicle data
  const fetchData = async (
    filters = isFiltersApplied ? filtersToApply : {}
  ) => {
    try {
      const queryParams = new URLSearchParams({
        ...filters,
        page, // Add the current page
        limit: rowsPerPage, // Add the number of rows per page
        sortField: sortConfig.key, // Sort configuration
        sortOrder: sortConfig.direction,
      }).toString();
      const response = await get(
        `/scope1/mobileCombustion/getAllOnRoadVehicles?${queryParams}`
      );
      setData(response.data.data); // Update the user list
      setTotalPages(response.data.totalPages); // Update total pages for pagination
      const uniqueValues = await fetchUniqueValues();
      setUniqueValues(uniqueValues);
      // Refetch card data after deletion
    } catch (error) {
      console.error("Error fetching users:", error);
    }
  };

  useEffect(() => {
    fetchData();
  }, [page, rowsPerPage, sortConfig]);

  const fetchCardData = async () => {
    try {
      const response = await post(
        `/scope1/mobileCombustion/onRoadcardData?month=${selectedMonth}&year=${selectedYear}&fuelType=${selectedFuelType}`,
        {
          fuelType: selectedFuelType,
        }
      );

      setApiData(response.data.data);

      // Extract unique fuel types from API response
      const newFuelTypes = response.data.data.total.map(
        (item) => item.fuelType
      );

      // Merge new values with existing values (avoid duplicates)
      setUniqueValues((prevValues) => ({
        ...prevValues,
        fuelType: [
          ...new Set([...(prevValues.fuelType || []), ...newFuelTypes]),
        ],
      }));

      // Ensure the selected fuelType exists in the list
      if (response.data.data.total?.length > 0) {
        const fuelTypeExists = response.data.data.total.some(
          (item) => item.fuelType === selectedFuelType
        );
        if (!fuelTypeExists) {
          setSelectedFuelType(response.data.data.total[0].fuelType);
        }
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    if (!selectedFuelType && uniqueValues.fuelType?.length > 0) {
      setSelectedFuelType(uniqueValues.fuelType[0]);
    }
  }, [uniqueValues.fuelType]);

  useEffect(() => {
    if (selectedFuelType) {
      fetchCardData();
    }
  }, [selectedFuelType, selectedMonth, selectedYear]);

  if (!Array.isArray(apiData.total)) return <div>Loading...</div>;

  const handleMenuClick = (event, element) => {
    setAnchorEl(event.currentTarget);
    setSelectedData(element);
    setElement(element);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setSelectedData(null);
  };

  const handleEdit = () => {
    handleMenuClose();
    setAddData(true);
    setViewData(false);
  };

  const handleView = () => {
    handleMenuClose();
    setViewData(true);
    setAddData(false);
  };

  const handleDelete = () => {
    handleMenuClose();
    setDeleteDialog(true);
  };

  const handleDeleteAggree = async () => {
    try {
      const res = await put(
        `/scope1/mobileCombustion/deleteOnRoadVehicles?Id=${element._id}`
      );
      setDeleteDialog(false);
      setsnackOpen({
        open: true,
        message: res.data.message,
        severity: "success",
      });
      fetchData();
      fetchCardData();
    } catch (err) {
      console.log(err);
      setsnackOpen({
        open: true,
        message: err.data?.response.message ?? "network Error",
        severity: "error",
      });
    }
  };
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const filtersToApply = {
    startDate: tempFilter?.startDate
      ? tempFilter?.startDate.format("YYYY-MM-DD")
      : "",
    endDate: tempFilter?.endDate
      ? tempFilter?.endDate.format("YYYY-MM-DD")
      : "",
    startMonth: tempFilter?.startMonth
      ? tempFilter?.startMonth.format("YYYY-MM")
      : "",
    endMonth: tempFilter?.endMonth
      ? tempFilter?.endMonth.format("YYYY-MM")
      : "",
    ownershipType: tempFilter?.ownershipType ? tempFilter?.ownershipType : "",
    vehicleType: tempFilter?.vehicleType ? tempFilter?.vehicleType : "",
    fuelType: tempFilter?.fuelType ? tempFilter?.fuelType : "",
    minFuelConsumed: tempFilter?.quantityRange.min || "",
    maxFuelConsumed: tempFilter?.quantityRange.max || "",
    minDistance: tempFilter?.distanceRange.min || "",
    maxDistance: tempFilter?.distanceRange.max || "",
  };

  // function to validate filters
  const validateFilters = () => {
    let isValid = true;
    const newErrors = {
      Date: false,
      Ownership: false,
      // "Vehicle Type": false,
      // "Fuel Type": false,
      "Fuel Consumed": false,
      "Distance Covered": false,
    };

    if (selectedFilter === "Date") {
      const today = new Date(); // Get the current date

      // Ensure that startDate and endDate are not greater than today's date
      if (startDate && startDate > today) {
        newErrors.Date = "Start date cannot be in the future";
        isValid = false;
      }

      if (endDate && endDate > today) {
        newErrors.Date = "End date cannot be in the future";
        isValid = false;
      }

      // Ensure that the startDate is less than or equal to the endDate
      if (startDate && endDate && startDate > endDate) {
        newErrors.Date = "End date must be greater than Start date";
        isValid = false;
      }
    }

    if (selectedFilter === "Fuel Consumed") {
      const min = parseFloat(quantityRange.min);
      const max = parseFloat(quantityRange.max);

      if (min && isNaN(min)) {
        newErrors["Fuel Consumed"] = "Min consumption must be a valid number";
        isValid = false;
      }

      if (max && isNaN(max)) {
        newErrors["Fuel Consumed"] = "Max consumption must be a valid number";
        isValid = false;
      }

      if (!isNaN(min) && !isNaN(max) && min > max) {
        newErrors["Fuel Consumed"] =
          "Min consumption cannot be greater than max consumption";
        isValid = false;
      }
    }
    if (selectedFilter === "Distance Covered") {
      const min = parseFloat(distanceRange.min);
      const max = parseFloat(distanceRange.max);

      if (min && isNaN(min)) {
        newErrors["Distance Covered"] = "Min hours must be a valid number";
        isValid = false;
      }

      if (max && isNaN(max)) {
        newErrors["Distance Covered"] = "Max hours must be a valid number";
        isValid = false;
      }

      if (!isNaN(min) && !isNaN(max) && min > max) {
        newErrors["Distance Covered"] =
          "Min hours cannot be greater than max consumption";
        isValid = false;
      }
    }

    setErrors(newErrors);
    return isValid;
  };

  // Applying selected filters
  const handleApplyFilters = () => {
    if (!validateFilters()) return;
    setPage(1);
    setStartDate(tempFilter?.startDate);
    setEndDate(tempFilter?.endDate);
    setSelectedFields({
      ownershipType: tempFilter?.ownershipType || [],
      vehicleType: tempFilter?.vehicleType || [],
      fuelType: tempFilter?.fuelType || [],
    });
    setQuantityRange(tempFilter?.quantityRange || { min: "", max: "" });
    setDistanceRange(tempFilter?.distanceRange || { min: "", max: "" });
    setStartMonth(tempFilter?.startMonth);
    setEndMonth(tempFilter?.endMonth);
    fetchData(filtersToApply);
    handleAppliedFilters();
    setDrawerFilterOpen(false);
  };

  const handleResetFilters = async () => {
    setTempFilter({
      startDate: null,
      endDate: null,
      startMonth: null,
      endMonth: null,
      ownershipType: [],
      vehicleType: [],
      fuelType: [],
      quantityRange: { min: "", max: "" },
      distanceRange: { min: "", max: "" },
    });
    setStartDate(null);
    setEndDate(null);
    setStartMonth(null);
    setEndMonth(null);
    setSelectedFields({
      ownershipType: [],
      vehicleType: [],
      fuelType: [],
    });
    setQuantityRange({ min: "", max: "" });
    setDistanceRange({ min: "", max: "" });
    // Call fetchData without any filters
    await fetchData({});
    setErrors({});
    setAppliedFilters({});
    setIsFiltersApplied(false);
    setDrawerFilterOpen(false);
  };

  const handleAppliedFilters = () => {
    const isDateApplied = tempFilter?.startDate || tempFilter?.endDate;
    const isMonthApplied = tempFilter?.startMonth || tempFilter?.endMonth;
    const isFuelTypeApplied = tempFilter.fuelType?.length > 0;
    const isVehicleTypeApplied = tempFilter.vehicleType?.length > 0;
    const isOwnershipTypeApplied = tempFilter.ownershipType?.length > 0;
    const isQuantityRangeApplied =
      tempFilter?.quantityRange.min && tempFilter?.quantityRange.max;
    const isHoursRangeApplied =
      tempFilter?.distanceRange.min && tempFilter?.distanceRange.max;

    setIsFiltersApplied(
      isDateApplied ||
        isMonthApplied ||
        isFuelTypeApplied ||
        isVehicleTypeApplied ||
        isQuantityRangeApplied ||
        isHoursRangeApplied ||
        isOwnershipTypeApplied
    );

    setAppliedFilters((prevAppliedFilters) => ({
      ...prevAppliedFilters,
      Date: isDateApplied,
      "Consumption Month": isMonthApplied,
      Ownership: isOwnershipTypeApplied,
      "Vehicle Type": isVehicleTypeApplied,
      "Fuel Type": isFuelTypeApplied,
      "Fuel Consumed": isQuantityRangeApplied,
      "Distance Covered": isHoursRangeApplied,
    }));
  };

  // Handle Sorting function
  const handleSort = (column, direction) => {
    setSortConfig({ key: column, direction });
  };

  const StyledPaginationItem = styled(PaginationItem)(({ theme }) => ({
    "&.Mui-selected": {
      backgroundColor: "green",
      color: "#fff",
      fontWeight: "bold",
    },
    "&:hover": {
      backgroundColor: "#ededed",
    },
  }));

  const handleFilterDrawer = () => {
    setTempFilter({
      startDate: startDate,
      endDate: endDate,
      startMonth: startMonth,
      endMonth: endMonth,
      ownershipType: selectedFields.ownershipType,
      vehicleType: selectedFields.vehicleType,
      fuelType: selectedFields.fuelType,
      quantityRange: quantityRange,
      distanceRange: distanceRange,
    });
    setDrawerFilterOpen(false);
  };

  const columnHeadings = [
    { title: "Date", fieldName: "createdAt" },
    { fieldName: "consumptionPeriod", title: "Consumption Month" },
    { fieldName: "transportType", title: "Transport Type " },
    { fieldName: "fuelType", title: "Fuel Type" },
    { fieldName: "fuelConsumed", title: "Fuel Consumed" },
    { fieldName: "ownershipType", title: "Ownership" },
    // { fieldName: "distanceCovered", title: "Distance Covered" },
  ];

  const renderSelectedFilter = () => {
    switch (selectedFilter) {
      case "Date":
        return (
          <DateRangePickerComponent
            startDate={tempFilter?.startDate}
            endDate={tempFilter?.endDate}
            setStartDate={(date) =>
              setTempFilter((prev) => ({ ...prev, startDate: date }))
            }
            setEndDate={(date) =>
              setTempFilter((prev) => ({ ...prev, endDate: date }))
            }
            setErrors={setErrors}
          />
        );
      case "Consumption Month":
        return (
          <MonthYearFilter
            startMonth={tempFilter?.startMonth}
            endMonth={tempFilter?.endMonth}
            setStartMonth={(month) =>
              setTempFilter((prev) => ({ ...prev, startMonth: month }))
            }
            setEndMonth={(month) => {
              setTempFilter((prev) => ({ ...prev, endMonth: month }));
            }}
            setErrors={setErrors}
            errors={errors.Month}
          />
        );
      case "Ownership":
        return (
          <MultiSelect
            title="Ownership"
            selectedFields={tempFilter}
            setSelectedFields={(updater) => {
              setTempFilter((prev) => {
                const newValue =
                  typeof updater === "function" ? updater(prev) : updater;
                return {
                  ...prev,
                  ownershipType: newValue.ownershipType || newValue,
                };
              });
            }}
            errors={errors["Ownership Type"]}
            setErrors={setErrors}
            field="ownershipType"
            data={uniqueValues.ownershipType}
          />
        );
      case "Vehicle Type":
        return (
          <MultiSelect
            title="Vehicle Type"
            url={`${api}/master/getAllEquipmentTypes`}
            selectedFields={tempFilter}
            setSelectedFields={(updater) => {
              setTempFilter((prev) => {
                const newValue =
                  typeof updater === "function" ? updater(prev) : updater;
                return {
                  ...prev,
                  vehicleType: newValue.vehicleType || newValue,
                };
              });
            }}
            errors={errors["Vehicle Type"]}
            setErrors={setErrors}
            field="vehicleType"
            data={uniqueValues.vehicleType}
          />
        );
      case "Fuel Type":
        return (
          <MultiSelect
            title="Fuel Type"
            selectedFields={tempFilter}
            setSelectedFields={(updater) => {
              setTempFilter((prev) => {
                const newValue =
                  typeof updater === "function" ? updater(prev) : updater;
                return {
                  ...prev,
                  fuelType: newValue.fuelType || newValue,
                };
              });
            }}
            errors={errors["Fuel Type"]}
            setErrors={setErrors}
            field="fuelType"
            data={uniqueValues.fuelType}
          />
        );
      case "Fuel Consumed":
        return (
          <Range
            title="Fuel Consumed"
            selectedRange={tempFilter?.quantityRange}
            setSelectedRange={(data) => {
              setTempFilter((prev) => ({
                ...prev,
                quantityRange: data,
              }));
            }}
            placeholderMin="Min Consumed"
            placeholderMax="Max Consumed"
            errors={errors["Fuel Consumed"]}
            setErrors={setErrors}
          />
        );
      case "Distance Covered":
        return (
          <Range
            title="Distance Covered"
            selectedRange={tempFilter?.distanceRange}
            setSelectedRange={(data) => {
              setTempFilter((prev) => ({
                ...prev,
                distanceRange: data,
              }));
            }}
            placeholderMin="Min Covered"
            placeholderMax="Max Covered"
            errors={errors["Distance Covered"]}
            setErrors={setErrors}
          />
        );
      default:
        return null;
    }
  };

  return (
    <MainDashboardLayout sidebar={<Scope1Layout />}>
      <Unauthorized requiredModule="Environment | Scope 1 | Mobile Combustion">
        <Box
          sx={{
            backgroundColor: "#ededed",
          }}
        >
          <MessagePopup {...{ snackOpen, setsnackOpen }} />{" "}
          {/*Message popup for success or failure */}
          {/* View log, Edit, delete menus */}
          <AddOnRoadVahicle
            id={element ? element._id : ""}
            addData={addData}
            setAddData={setAddData}
            data={element}
            addUrl={`${api}/scope1/mobileCombustion/addOnRoadVehicles`}
            updateUrl={`${api}/scope1/mobileCombustion/updateOnRoadVehicles`}
            // details={vehicle}
            fetchData={fetchData}
            setsnackOpen={setsnackOpen}
            inputData={inputData}
            fetchCardData={fetchCardData}
          />
          <ViewOnRoadVahicle
            id={element ? element._id : ""}
            data={element}
            viewData={viewData}
            setViewData={setViewData}
            inputData={inputData}
            handleEdit={handleEdit}
          />
          <Box>
            <Cards
              data={bannerData}
              title="Mobile Combustion"
              onFilterChange={(key, value) => {
                if (key === "fuelType") {
                  setSelectedFuelType(value); // Update fuel type
                }
                if (key === "date") {
                  setSelectedMonth(value.month);
                  setSelectedYear(value.year);
                }
              }}
              setSelectedMonth={setSelectedMonth}
              setSelectedYear={setSelectedYear}
              selectedMonth={selectedMonth}
              selectedYear={selectedYear}
            />
          </Box>
          {deleteDialog && (
            <DeleteAlertDialog
              {...{
                deleteDialog,
                setDeleteDialog,
                id: element._id,
                url: `${api}/scope1/mobileCombustion/deleteOnRoadVehicles`,
                setsnackOpen,
                fetchData,
                fetchCardData,
              }}
            />
          )}
          {/* Filter Drawer */}
          {drawerFilterOpen && (
            <FilterDrawer
              {...{
                renderSelectedFilter,
                drawerFilterOpen,
                setDrawerFilterOpen,
                handleApplyFilters,
                handleFilterDrawer,
                setSelectedFilter,
                handleResetFilters,
                selectedFilter,
                filters,
                appliedFilters,
                selectedFields,
                setSelectedFields,
              }}
            />
          )}
          {/* Top Box for Heading, Filter Button, Add Data Button */}
          <TopMenuUpload
            setData={setElement}
            setAddData={setAddData}
            {...{
              setBulkUploadModal,
              setDrawerFilterOpen,
              filterApplied: isFiltersApplied,
            }}
          />
          <TableContainer component={Paper} sx={{ maxWidth: "100%" }}>
            <Box>
              <TableHeading heading={"On Road Vehicles"} />
              <Box
                sx={{
                  display: "grid",
                  gridTemplateColumns: "12% 16% 16% 17% 16% 15% 8%",
                  borderBottom: "1px solid #ddd",
                  borderTop: "1px solid #ddd",
                }}
              >
                {columnHeadings.map((el) => (
                  <ColumnHeadings
                    key={el}
                    {...{
                      title: el.title,
                      key: el.title,
                      handleSort,
                      field: el.fieldName,
                      sortConfig,
                    }}
                  />
                ))}
                <Typography
                  sx={{
                    fontWeight: "bold",
                    padding: "8px 12px",
                    textAlign: "center",
                  }}
                >
                  Action
                </Typography>
              </Box>
              {data.length === 0 ? (
                <NoDataFound />
              ) : (
                data &&
                data.map((item) => (
                  <Box
                    key={item._id}
                    sx={{
                      display: "grid",
                      gridTemplateColumns: "12% 16% 16% 17% 16% 15% 8%",
                      borderBottom: "1px solid #ddd",
                    }}
                  >
                    {columnHeadings.map((el) => (
                      <TableContent
                        key={el.fieldName}
                        {...{
                          fieldData:
                            el.fieldName === "consumptionPeriod"
                              ? getMonthName(item[el.fieldName]?.month) +
                                " " +
                                item[el.fieldName]?.year
                              : el.fieldName === "fuelConsumed"
                              ? `${truncateNumber(
                                  item[el.fieldName]?.value || 0
                                )} ${item[el.fieldName]?.unit || ""}`
                              : el.fieldName === "ownershipType"
                              ? item[el.fieldName] || "Leased"
                              : typeof item[el.fieldName] === "object" &&
                                item[el.fieldName] !== null &&
                                item[el.fieldName].name
                              ? item[el.fieldName].name
                              : item[el.fieldName],
                          dateField:
                            el.fieldName === "createdAt"
                              ? item.createdAt
                              : false,
                        }}
                      />
                    ))}
                    {/* Menu Action Icon */}
                    <MenuIcon {...{ handleMenuClick, field: item }} />
                  </Box>
                ))
              )}
            </Box>
          </TableContainer>
          {/* Pagination */}
          {totalPages > 1 && (
            <PaginationBox
              {...{
                totalPages,
                page,
                handleChangePage,
                StyledPaginationItem,
              }}
            />
          )}
          <MenuActions
            {...{
              id: element?._id,
              handleView,
              handleEdit,
              handleDelete,
              anchorEl,
              handleMenuClose,
            }}
          />
          {/*Add,Edit,Delete Icons & function calls */}
        </Box>
        {bulkUploadModal && (
          <BulkUploadModal
            onCloseBulkUpload={handleCloseBulkUpload}
            isBulkUploadModal={bulkUploadModal}
            setsnackOpen={setsnackOpen}
            excelData={excelData}
            setMatchData={setMatchData}
            formDataBulkUpload={formDataBulkUpload}
            setFormDataBulkUpload={setFormDataBulkUpload}
            errorClose={uploadErrorClose}
            setBulkUploadTable={setBulkUploadTable}
            setBulkUploadModal={setBulkUploadModal}
            fileName={"On Road Vehicles"}
            url={"/scope1/mobileCombustion/onroad/bulkupload"}
            setJsonBulkUpload={setJsonBulkUpload}
          />
        )}
        {bulkUploadTable && (
          <BulkUpload
            matchData={matchData}
            setMatchData={setMatchData}
            onClose={() => setBulkUploadTable(false)}
            bulkUploadTable={bulkUploadTable}
            formData={formDataBulkUpload}
            setFormData={setFormDataBulkUpload}
            url={`/master/scope1/getAllVehicle`}
            submitUrl={`/master/scope1/addVehicle`}
            bulkuploadInputData={bulkuploadInputData}
            onConfirm={() => {
              // Handle the bulk upload confirmation here
              setBulkUploadTable(true);
              fetchData();
              // setsnackOpen({
              //   open: true,
              //   message: "Bulk upload completed successfully!",
              //   severity: "success",
              // });
            }}
            jsonBulkUpload={jsonBulkUpload}
            bulkUploadUrl={`/scope1/mobileCombustion/onroad/jsonupload`}
            setsnackOpen={setsnackOpen}
          />
        )}
      </Unauthorized>

      {/* </DashboardLayout> */}
    </MainDashboardLayout>
  );
};

export default OnRoadVahicle;
